import { useContext } from 'react';

import PageContext from '@/Providers/PageContextProvider/PageContext';
import type { SignInExperienceResponse } from '@/types';

export const useCustomRegistrationConfig = ():
  | SignInExperienceResponse['customRegistration']
  | undefined => {
  const { experienceSettings } = useContext(PageContext);
  return experienceSettings?.customRegistration;
};
